import { Component, Input, OnInit } from '@angular/core';
import { DiasLibresService } from 'src/app/pages/services/diasLibres/diasLibres.service';
import { HorasExtrasService } from 'src/app/pages/services/horasExtras/horasExtras.service';
import { DiasLibres } from 'src/app/shared/models/diasLibres.interface';
import { HorasExtras } from 'src/app/shared/models/horasExtras.interface';

@Component({
  selector: 'app-modal-view-horas-extras',
  templateUrl: './modal-view-horas-extras.component.html',
  styleUrls: ['./modal-view-horas-extras.component.css']
})
export class ModalViewHorasExtrasComponent implements OnInit {

  @Input() idTrabajador: number = 0;
  horasExtras: HorasExtras[] = [];
  horasLibres: DiasLibres[] = [];
  horasExtrasTotales: number = 0;
  horasLibresTotales: number = 0;
  horasExtrasPeriodo: HorasExtras[] = [];
  horasLibresPeriodo: DiasLibres[] = [];
  tieneHorasExtras: boolean = false;

  constructor(
    private horasExtrasService: HorasExtrasService,
    private diasLibresService: DiasLibresService
  ) { }

  ngOnInit(): void {
    // console.log(this.idTrabajador);
    this.getHorasExtras();
    this.getHorasDiaslibres();
  }

  getHorasExtras() {
    this.horasExtrasService.traerTodasTrabajadorAsync(this.idTrabajador).then(res => {
      if (res.success) {
        this.horasExtras = res.data;
        console.log("HORAS EXTRAS: ",this.horasExtras);
        this.horasExtrasPeriodo = this.horasExtras.filter(hora => {
          console.log("HORITA: ", hora);
          const fecha = new Date(hora.fecha);
          const hoy = new Date();
          return fecha.getFullYear() === hoy.getFullYear() && fecha.getMonth()  === hoy.getMonth() - 1;
        });
        console.log("HORAS EXTRAS: ",this.horasExtrasPeriodo);
        if (this.horasExtrasPeriodo.length > 0) this.tieneHorasExtras = true
        this.horasExtrasTotales = this.horasExtrasPeriodo.reduce((total, hora: any) => total + parseFloat(hora.horasExtras), 0);
      } else {
        console.error(res.msg);
      }
    });
  }

    getHorasDiaslibres() {
      this.diasLibresService.traerTodasTrabajadorAsync(this.idTrabajador).then(res => {
        if (res.success) {
          this.horasLibres = res.data;
          this.horasLibresPeriodo = this.horasLibres.filter(dia => {
            const fecha = new Date(dia.fecha);
            const hoy = new Date();
            return fecha.getFullYear() === hoy.getFullYear() && fecha.getMonth() === hoy.getMonth() - 1;
          })
          this.horasLibresTotales = this.horasLibresPeriodo.reduce((total, dia: any) => total + parseFloat(dia.horas), 0);
        } else {
          console.error(res.msg);
        }
      });
  }



}
